import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable()
export class SharedService {
    // Observable string streams
    public changeEmitted$;
    private emitChangeSource = new Subject();

    constructor() {
        this.changeEmitted$ = this.emitChangeSource.asObservable();
    }

    // Service message commands
    emitChange(change: string) {
        this.emitChangeSource.next(change);
    }
}
